import React from 'react';
import { LinkProps } from '@resideo/blueprint-react';
import useMedia from 'hooks/useMedia';
import { StyledLinkDesktop, StyledLinkMobile } from './Link.style';

const Link: React.FC<LinkProps> = ({ children, ...rest }) => {
  const isMobile = useMedia('(max-width: 62rem)');
  const StyledLink = isMobile ? StyledLinkMobile : StyledLinkDesktop;
  return <StyledLink {...rest}>{children}</StyledLink>;
};

export default Link;
